import type { TenantConfig } from '@/types/TenantConfig'

export const rockhall: TenantConfig = {
  logo: 'assets/rockhall/static/logo.png',
  themeOptions: {
    mobileFooter: {
      textColor: '#161314',
      priceTextColor: '#161314',
    },
  },
  teaserImageSize: {
    width: 350,
    height: 350,
  },
  // Typography.com fonts don't work in Stripe's <iframe>.
  // stripe: {
  //   font: 'https://cloud.typography.com/6910514/7668152/css/fonts.css',
  // },
  componentOptions: {
    cartWidget: {
      dateTimeFormat: 'ddd D MMM @ h:mm A',
    },

    checkoutRoute: {
      stripeWallets: true,
    },
  },
  i18nOverrides: {
    en: {
      namedMembers: {
        roleTitles: {
          'second-card': 'Would you like a second membership card for another adult in your household?',
        },
      },
      checkoutRoute: {
        title: 'Complete Your Order',
      },
      completedOrdersRoute: {
        title: '<span>Confirmed!</span> Your rock & roll adventure begins',
      },
      reserveDateFirst: {
        selectDateLabel: 'Choose a Date',
      },
      selectAvailableSession: {
        title: 'Choose an Entry Time',
      },
      selectTickets: {
        title: 'Choose Tickets',
      },
      stepperGroupTitles: {
        members: 'Choose the number of member tickets',
        guests: 'Choose the number of non-member tickets',
        default: 'Choose the number of tickets',
      },
      applyPromoCodes: {
        applyAnotherPromoCodeLabel: 'Add another discount code',
        applyPromoCodeLabel: 'Add discount code',
      },
      termsModal: {
        title: 'Release and Waiver of Liability',
      },
    },
  },
  customContent: [
    {
      key: 'guest-shopping',
      regions: ['home-guest-experience'],
      template: `
        <p>You can shop as a guest without having to register.</p>
      `,
    },
  ],
}
